/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetAlertsExceedResponse {
    getFixupPrototypeFunction() { return BudgetAlertsExceedResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetAlertsExceedResponse>): BudgetAlertsExceedResponse {
        let obj = Object.assign(new BudgetAlertsExceedResponse(), model);
        BudgetAlertsExceedResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetAlertsExceedResponse>): BudgetAlertsExceedResponse {
        if (!model) return null;
        return BudgetAlertsExceedResponse.newInstance(<BudgetAlertsExceedResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetAlertsExceedResponse) {
        if (!obj) return;

        models.BudgetAlertsExceedResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetAlertsExceedResponse): boolean {
        Object.setPrototypeOf(obj, BudgetAlertsExceedResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_alerts_exceed_budgets_count === undefined) {
            this.total_alerts_exceed_budgets_count = 0;
        }
    }

    /**
     * alert exceeded budget count
     */
    total_alerts_exceed_budgets_count: number;

}
